import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GetFileContentFromCacheIdArgs, GetFileContentFromCacheIdResponse, KemuHubFunctions } from '@kemu-io/hs-types';
import { useDebouncedCallback } from 'use-debounce';
import { useDispatch, useSelector } from 'react-redux';
import LoadingEnvironmentScreen from '../LoadingEnvironmentScreen/LoadingEnvironmentScreen';
import routes from '@common/routes';
import useTranslation from '@hooks/useTranslation';
import { importRecipeFromContentsAction } from '@src/app/reducers/workspace/importRecipeFromContentsReducer';
import connectionManager from '@src/app/kemuHub/connectionManager';
import { selectCurrentRecipePoolId } from '../Workspace/workspaceSlice';
import DesktopRecipeScreen from '../DesktopRecipeScreen/DesktopRecipeScreen';


const LoadRecipeFileContentsFromDisk = (): React.JSX.Element | null => {
  const { cacheId } = useParams<{ cacheId?: string }>();
  const recipePoolId = useSelector(selectCurrentRecipePoolId);
  // const { connector, status, online, isReady } = useHubContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const t = useTranslation('Recipe.Import');

  const rebootToInstall = useDebouncedCallback(async () => {
    if (!cacheId) { return navigate(routes.getBaseRoute()); }
    const args: GetFileContentFromCacheIdArgs = [{
      cacheId,
    }];

    
    const link = await connectionManager.startInGuestMode();

    link.executeGuestHubFunction<GetFileContentFromCacheIdResponse>({
      name:KemuHubFunctions.GetFileContentFromCacheId, 
      args,
    }).then((res) => {
      if (!res) { throw new Error(`Invalid response from hub`); }
      const [file] = res;
      dispatch(importRecipeFromContentsAction({
        contents: file.contents,
        navigate,
        loadedFromDisk: true,
      }));

    }).catch(err => {
      console.error(`Failed to load recipe file contents from disk: ${err}`);
      navigate(routes.getBaseRoute());
    });
  }, 200);

  // Aborts loading after 2 seconds
  const navigateToBase = useDebouncedCallback(() => {
    console.log('Failed to communicate with hub, aborting recipe loading');
    navigate(routes.getBaseRoute());
  }, 4000);

  useEffect(() => {
    if(!recipePoolId){
      navigateToBase.cancel();
      rebootToInstall();
    }

    return () => {
      rebootToInstall.cancel();
    }
  }, [cacheId, recipePoolId]);

  // Show recipe screen once the recipe is loaded
  if(recipePoolId){
    return (
      <DesktopRecipeScreen />
    )
  }

  return (
    <LoadingEnvironmentScreen
      title={t('Loading')}
    />
  );
};

export default LoadRecipeFileContentsFromDisk;
